import React from 'react';
import { connect } from 'react-redux';
import { movil } from '../app-movil';
import { goTo } from '../tools';

const mapState = (state) => {
	return {};
}
const mapDispatch = (dispatch) => {
	return {
		resetPaso: () => {
			dispatch({ "type": "OLVIDE_RESET_PASO" });
		}
	}
}

class UsuarioBloqueado extends React.Component {
	back = () => {
		let mensaje = { "return": "login", "procesa": "recupera" };
		movil("cambiarcontrasena", mensaje);
		this.props.resetPaso();
		goTo("login");
		//window.location.href = '/#!/login';
	}
	render() {
		return <div>
			<div className="login-form">
				<div className="h1-titulo text-center">Usuario bloqueado</div>
				<div className="text-center mt-70">
					<div className="mt-25">
						<p>Tu cuenta ha sido bloqueada temporalmente debido a varios intentos de inicio de sesión incorrectos. 
						Solicita tu verificación por SMS y recibe un código de verificación (OTP) para cambiar tu contraseña.</p>
					</div>
				</div>
			</div>
			<div className="text-center mt-70">
				<button onClick={this.back} className="orange-rectangle">Aceptar</button>
			</div>
		</div>
	}
}

export default connect(mapState, mapDispatch)(UsuarioBloqueado);



// WEBPACK FOOTER //
// ./src/gnp-olvide/usuarioBloqueado.cmpt.js